export default __webpack_public_path__ + "static/media/summary.16b2843b.svg";